<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageGallery @toggleImage="onToggleImage" :showImage="showAssetInfo" overlay>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image"><transition name="fade" mode="out-in" appear><img :src="require('@/assets/images/' + assets[currentAsset].image)" alt=""></transition></div>                  
                  <div class="asset-info" v-if="currentAsset !== -1" :class="showAssetInfo ? 'show' : ''">                        
                        <p class="asset-name">Marketing Assets</p>
                        <div class="asset-items">
                            <button 
                                v-for="(asset, id) in assets"
                                @click="currentAsset = id;"
                                :key="id"
                                :class="[currentAsset === id ? 'active' : '']"
                            />
                        </div>
                        <div class='linear'>
                            <LinearButton dark back @click="goBack"></LinearButton>
                            <LinearButton dark @click="goForward"></LinearButton>
                        </div>
                    </div>       
            </div>
        </div>
    </template>
    </PageGallery>    
  </div>
</template>

<script>
import PageGallery from "@/patterns/PageGallery.vue";
import LinearButton from "@/patterns/LinearButton.vue";
export default {
  name: "StadiumPhotoGallery",
  components: {LinearButton, PageGallery },
  data: () => ({
    scrollContent: false, 
    currentAsset:0,
    showAssetInfo:true,
    assets:[
        {
            display_name:"Media Mesh",
            image:"marketing/venue_assets/media-mesh.jpg",
            content:"The Allegiant Stadium Media Mesh is the largest outdoor video display of NFL stadiums nationwide. Located on the exterior southeast side of the venue and facing south on Interstate 15, the Media Mesh spans 347’ wide and 78’ tall. The Media Mesh garners an estimated 1.7M daily impressions with a 24-hour showing and is visible from miles south of the venue.",
        },
        {
            display_name:"Freeway Marquee",
            image:"marketing/venue_assets/freeway-marquee.jpg",
            content:"Situated on the exterior north side of the venue directly on Interstate 15, the Marquee stands over 120 feet high (with a display space of over 10’ x 30’.) The Marquee is visible from both northbound and southbound Interstate 15, the main thoroughfare to and from the Las Vegas Strip.",
        },
        {
            display_name:"LED Billboards",
            image:"marketing/venue_assets/LED-billboards.jpg",
            content:"Allegiant Stadium features 9 large scale LED Billboards on venue property, serving an estimated 6M weekly impressions. The LED Billboards are visible from both northbound and southbound Interstate 15, as well as to local traffic traveling to the Las Vegas Strip.",
        },
        {
            display_name:"Box Office Marquee",
            image:"marketing/venue_assets/box-office-marquee.jpg",
            content:"The Box Office Marquee features over 95’ wide of scrolling or static text and is directly visible to southbound Interstate 15 traffic.",
        },
        {
            display_name:"South Video Board",
            image:"marketing/venue_assets/south-video-board.jpg",
            content:"The largest of all the interior boards, the South Video Board is a massive 253’ wide x 48’ tall and is situated directly above an ideal End Stage configuration.",
        },
        {
            display_name:"North Video Boards",
            image:"marketing/venue_assets/north-video-boards.jpg",
            content:"The north side of Allegiant Stadium features 4 large video boards. Included on the North Side are the Northeast and Northwest Video Boards measuring 121’ wide by 48’ tall along with the Auxiliary Boards at 32’ wide by 17’ tall each.",
        },
        {
            display_name:"Ribbon Boards",
            image:"marketing/venue_assets/ribbon-boards.jpg",
            content:"Two layers of immersive 4’ tall Ribbon Boards line the entire venue.",
        },
        {
            display_name:"Concourse & Elevator Displays",
            image:"marketing/venue_assets/concourse-&-elevator-displays.jpg",
            content:"Allegiant Stadium features over 2,200 digital screens located throughout stadium concourse, club spaces, and elevators.",
        }
    ]
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    goBack() {
        this.currentAsset = this.currentAsset - 1;
        if(this.currentAsset < 0) {
            this.currentAsset = this.assets.length - 1;
        }
    },
    goForward() {
        this.currentAsset = this.currentAsset + 1;
        if(this.currentAsset == this.assets.length) {
            this.currentAsset = 0;
        }
    },
    venueSelected(id) {
        this.currentAsset = id;
        this.showAssetInfo = true; 
    },
    onToggleImage(showImage) {
        this.showAssetInfo = showImage;
    },
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.linear {
    position: relative;
    margin-top:60px;
}
.asset-info {
    position: absolute;
    left:60px;
    bottom:130px;
    transition: transform 0.25s cubic-bezier(1, 0.5, 0.8, 1);
    transform:translateY(calc(100% + 130px));
    .asset-name {
        color: #FFFFFF;
        font-family: 'Gotham';
        font-size: 2rem;
        font-weight: 900;
        letter-spacing: 0;
        line-height:1;
        text-transform:uppercase;
    }
    .asset-content {
        color: #FFF;
        font-family: 'Montserrat';
        font-size: 1rem;
        letter-spacing: 0;
        line-height: 1.7;
        max-width: 640px;
    }
    .asset-items {
        font-size: 0;
        margin-top:25px;
        button {
            cursor: pointer;
            width:40px;
            height:6px;
            background-color: #4B4B4D;
            border:none;
            outline:none;
            transition: background-color 0.25s cubic-bezier(1, 0.5, 0.8, 1);
            &:not(last-child) {
                margin-right:5px;
            }
            &.active {
                background-color: #fff;;
            }
        }
    }
    &.show {
        transition-delay: 0.2s;
        transform:translateY(0);
    }
}
.selector {    
    position: relative;    
    width: 100%;
}
.view-asset {  
  font-size: 0.8em;    
  margin-top:30px;
}
a {    
    color: #FFF;
    font-family: "Gotham";
    font-weight:bold;
    font-size: 0.8em;
    text-transform: uppercase;        
    text-decoration: none;
    img {
        margin-right:15px;
    }
    img, span {
        vertical-align: middle;
    }
}
</style>